'use client';

import React from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

const cache = createCache({
  key: 'react-select',
  prepend: false,
});

/**
 * Provides a shared Emotion cache for react-select components to prevent
 * every instance from injecting their own 6+ style tags to document head.
 */
export default function EmotionCacheProvider({ children }: { children: React.ReactNode }) {
  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
